<template>
<section :class="classes">
	<Heading :level="1" text="Project Details - Part One" />

	<form @submit.prevent="saveAndSubmit" novalidate ref="form">
		<text-area
			name="ua_describeproposal"
			ref="ua_describeproposal"
			:value="formData.ua_describeproposal"
			:max-chars="5000"
			@emitFieldData="(val) => formData.ua_describeproposal = val"
			label-text="Describe, in a sentence or two, the growth objective, improvement need, or opportunity identified."
			required-error="Please enter your description."
			:validation-rules="[(v) => rules.containsLength(v, 100, 5000)]" />

		<text-area
			name="ua_descriptionofproject"
			ref="ua_descriptionofproject"
			:value="formData.ua_descriptionofproject"
			:max-chars="10000"
			@emitFieldData="(val) => formData.ua_descriptionofproject = val"
			label-text="Please describe the proposed project or activity."
			required-error="Please enter your description."
			:validation-rules="[(v) => rules.containsLength(v, 100, 10000)]" />
	</form>
</section>
</template>

<script>
// Please see childEntityParent mixin for common settings
import { formSteps } from '@/mixins/appFormSteps';
import { formValidator } from '@/mixins/formValidator';
import { validationRules } from '@/utilities/validationRules';

export default {
	name: 'ProjectDetailsOne',
	mixins: [formValidator, formSteps],
	props: {
		classes: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			rules: validationRules,
			formData: {
				ua_describeproposal: '',
				ua_descriptionofproject: ''
			}
		};
	}
};
</script>
